/* eslint-disable */
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { structuralClone } from '../../api-helpers';
import { CaseCustomerCreateMultipartBody, fixCaseCustomerCreateMultipartBodyToJson } from '../dto/case-customer-create-multipart-body';

export interface PostCaseCustomerCreateParams {
  body: CaseCustomerCreateMultipartBody;
}

export function httpPostCaseCustomerCreate(http: HttpClient, data: PostCaseCustomerCreateParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<void>;
export function httpPostCaseCustomerCreate(http: HttpClient, data: PostCaseCustomerCreateParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<void>>;
export function httpPostCaseCustomerCreate(http: HttpClient, data: PostCaseCustomerCreateParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return structuralClone(data).pipe(
    switchMap((dataClone) => {
      fixCaseCustomerCreateMultipartBodyToJson(dataClone.body);
      const body = dataClone.body;
      const form = new FormData();
      if (body.subject != null) {
        form.append('Subject', body.subject as unknown as string);
      }
      if (body.description != null) {
        form.append('Description', body.description as unknown as string);
      }
      if (body.request != null) {
        form.append('Request', body.request as unknown as string);
      }
      if (body.type != null) {
        form.append('Type', body.type as unknown as string);
      }
      if (body.product != null) {
        form.append('Product', body.product as unknown as string);
      }
      if (body.topic != null) {
        form.append('Topic', body.topic as unknown as string);
      }
      if (body.version != null) {
        form.append('Version', body.version as unknown as string);
      }
      if (body.activeMenuItem != null) {
        form.append('ActiveMenuItem', body.activeMenuItem as unknown as string);
      }
      if (body.errorMessage != null) {
        form.append('ErrorMessage', body.errorMessage as unknown as string);
      }
      if (body.callbackTime != null) {
        form.append('CallbackTime', body.callbackTime.toISOString() as unknown as string);
      }
      if (body.criticality != null) {
        form.append('Criticality', body.criticality as unknown as string);
      }
      if (body.billingRelevant != null) {
        form.append('BillingRelevant', body.billingRelevant as unknown as string);
      }
      if (body.file != null) {
        form.append('File', body.file);
      }
      return http.post<void>(`{placeholder}/Case/CustomerCreate`, form, options as any);
    })
  );
};

export const urlPostCaseCustomerCreate = (baseUrl: string, data: PostCaseCustomerCreateParams) => {
  return `${baseUrl}/Case/CustomerCreate`;
};
